var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertHumanTriggered01 = function SvgAlertHumanTriggered01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Layer 1",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "alert_human_triggered-01_svg2__a",
    x1: -11.74,
    x2: 160.63,
    y1: 162.99,
    y2: 8.4,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_human_triggered-01_svg2__a",
    id: "alert_human_triggered-01_svg2__b",
    x1: -0.68,
    x2: 171.69,
    y1: 175.32,
    y2: 20.73
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#alert_human_triggered-01_svg2__a",
    id: "alert_human_triggered-01_svg2__c",
    x1: 16.46,
    x2: 188.84,
    y1: 194.44,
    y2: 39.85
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M62.64 49.23a95 95 0 0 0-12.75-2.26c6.09-4.25 10.22-12.44 10.22-21.83 0-12.57-7.55-20.38-19.71-20.38s-19.71 7.81-19.71 20.38c0 9.37 4.11 17.55 10.18 21.8-4.28.45-8.52 1.21-12.73 2.3C6.44 52.25 0 58.68 0 67.36v49.65c0 9.02 6.85 16.53 15.8 17.97v58.89c0 .83.33 1.62.92 2.21s1.38.92 2.21.92H61.9c1.73 0 3.12-1.4 3.12-3.12v-58.89c8.95-1.44 15.8-8.95 15.8-17.97V67.37c0-8.65-6.62-15.26-18.17-18.13ZM26.95 25.14c0-12.3 8.43-14.13 13.46-14.13s13.46 1.84 13.46 14.13c0 10.3-6.04 18.67-13.46 18.67s-13.46-8.38-13.46-18.67m47.61 91.87c0 5.58-4.07 10.28-9.55 11.6v-46.5c0-1.73-1.4-3.12-3.12-3.12s-3.12 1.4-3.12 3.12v108.63H44.13v-46.87c0-1.73-1.4-3.12-3.12-3.12s-3.12 1.4-3.12 3.12v46.87H22.06V82.11c0-1.73-1.4-3.12-3.12-3.12s-3.12 1.4-3.12 3.12v46.5c-5.48-1.32-9.55-6.02-9.55-11.6V67.36c0-7.11 7.31-10.49 13.45-12.07 13.49-3.47 27.43-3.47 41.44 0 5.01 1.24 13.42 4.46 13.42 12.06V117Zm122.83-43.18-35.33-61.19c-3.48-6.03-9.72-9.63-16.68-9.63s-13.2 3.6-16.68 9.63L93.37 73.83c-3.48 6.03-3.48 13.23 0 19.26s9.72 9.63 16.68 9.63h70.65c6.96 0 13.2-3.6 16.68-9.63s3.48-13.23 0-19.26Zm-5.41 16.13c-2.35 4.07-6.56 6.5-11.26 6.5h-70.65c-4.7 0-8.91-2.43-11.26-6.5s-2.35-8.93 0-13.01l35.33-61.19c2.35-4.07 6.56-6.5 11.26-6.5s8.91 2.43 11.26 6.5l35.33 61.19c2.35 4.07 2.35 8.93 0 13.01Z",
    style: {
      fill: "url(#alert_human_triggered-01_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.39 59.78c-2.21 0-4-1.79-4-4v-22.9c0-2.21 1.79-4 4-4s4 1.79 4 4v22.9c0 2.21-1.79 4-4 4",
    style: {
      fill: "url(#alert_human_triggered-01_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.39 82.82c-.26 0-.53-.02-.79-.07-.25-.06-.5-.13-.75-.23-.24-.1-.47-.23-.69-.37-.21-.15-.42-.31-.6-.5a3.98 3.98 0 0 1-1.17-2.82c0-.27.02-.53.08-.79.05-.25.12-.5.22-.75.1-.24.23-.47.37-.69.15-.21.31-.42.5-.6.18-.19.39-.35.6-.5.22-.14.45-.27.69-.37.25-.1.5-.17.75-.23 1.3-.26 2.69.17 3.61 1.1.19.18.35.39.5.6.14.22.27.45.37.69.1.25.18.5.23.75.05.26.07.52.07.79 0 1.05-.42 2.08-1.17 2.82a3.98 3.98 0 0 1-2.82 1.17",
    style: {
      fill: "url(#alert_human_triggered-01_svg2__c)"
    }
  }));
};
export default SvgAlertHumanTriggered01;